export default {
  COMPNAME: "avue-echart-",
  NAME: "list",
  DEAFNAME: 'item',
  password: 'avue_data'
}
// export const url = 'https://data.bladex.vip/blade-visual'
// export const url = 'http://127.0.0.1:8050/blade-visual'
export const url = 'https://dpapi.bsmyit.com/blade-visual'
